import { render } from "./HelpAoeEduLicensing.vue?vue&type=template&id=f2a38830&scoped=true"
import script from "./HelpAoeEduLicensing.vue?vue&type=script&lang=js"
export * from "./HelpAoeEduLicensing.vue?vue&type=script&lang=js"

import "./HelpAoeEduLicensing.vue?vue&type=style&index=0&id=f2a38830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a38830"]])

export default __exports__